<template>
  <a
    href="#"
    @click.prevent="$parent.$emit('close')"
    class="ts-absolute ts-text-lg"
    style="top: 20%; right: 10px;"
  >
    <i class="fas fa-times"></i>
  </a>
</template>

<script>
export default {
  name: 'TsModalCloseButton'
}
</script>
